import $api from '../../utils/api.js'


const state = () => ({
    partner: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Partner'
    },
    formdata:{
        id:'',
        name:'',
        phone:'',
        photo:'',
        email:'',
        address:'',
        sosmed_link:'',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.partner = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            phone:payload.phone,
            photo:payload.photo,
            email:payload.email,
            address:payload.address,
            sosmed_link:payload.sosmed_link,
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            phone:'',
            photo:'',
            email:'',
            address:'',
            sosmed_link:'',
        },
        state.errors = []
    },
    CLEAR_PARTNER(state){
        state.partner = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getPartner({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`partner?page=${state.partner.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createPartner({ commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`partner`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    updatePartner({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`partner/${state.formdata.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deletePartner({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`partner/${payload}`)
            .then(() => {
                dispatch('getPartner').then(() => resolve())
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}